import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EventDocumentationReviewList } from '../services/types/event.types';
import { DocumentApprovalStatus } from '../dto/event-documentation';

export interface DocumentationReviewState {
  documents: EventDocumentationReviewList;
}

const initialState: DocumentationReviewState = {
  documents: [],
};

const documentationReview = createSlice({
  name: 'documentation-review',
  initialState,
  reducers: {
    setDocuments(state, action: PayloadAction<EventDocumentationReviewList>) {
      state.documents = action.payload;
    },
    rejectDocument(
      state,
      action: PayloadAction<{ id: string; justification: string }>,
    ) {
      const { id, justification } = action.payload;
      const document = state.documents.find(doc => doc.id === id);

      if (document) {
        document.justification = justification;
        document.status = DocumentApprovalStatus.REJECTED;
        document.documents = document.documents.map(item => ({
          ...item,
          status: DocumentApprovalStatus.REJECTED,
          justification,
        }));
      }
    },
    approveDocument(state, action: PayloadAction<{ id: string }>) {
      const { id } = action.payload;
      const document = state.documents.find(doc => doc.id === id);

      if (document) {
        document.status = DocumentApprovalStatus.APPROVED;
        document.documents = document.documents.map(item => ({
          ...item,
          status: DocumentApprovalStatus.APPROVED,
        }));
      }
    },
  },
});

export const { setDocuments, rejectDocument, approveDocument } =
  documentationReview.actions;

export default documentationReview.reducer;
